import React from 'react';
import styles from './starListQuery.module.scss';
import { Commun } from '../../utils/axios';
class StarListQuery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      queryDate: '',
      queryType: 1,
      queryMonthList: [],
      selectToggle: false,
      resultMonthList: [],
      starTotal: 0,
      tabData: [
        {
          id: 1,
          active: true,
          val: '星星收入'
        },
        {
          id: 0,
          active: false,
          val: '星星支出'
        }
      ]
    }
  }

  componentDidMount() {
    let queryMonthList = this.recentOneyear();
    let { tabData } = this.state;
    this.setState({
      queryMonthList,
      queryDate: queryMonthList.find(item => item.current).val,
      queryType: tabData.find(item => item.active).id
    }, () => {
      // console.log(this.state.queryMonthList, 'queryMonthList')
      this.search();
    })
  }

  componentWillMount() {
  }

  recentOneyear = () => {
    let dataArr = [];
    let data = new Date();
    data.setMonth(data.getMonth() + 1, 1);
    for (let i = 0; i < 12; i++) {
      data.setMonth(data.getMonth() - 1);
      let m = data.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      dataArr.push({ current: i === 0, val: data.getFullYear() + "-" + (m) });
    }
    return dataArr;
  }

  closeToggleUl = () => {
    let { selectToggle } = this.state;
    selectToggle && this.setState({
      selectToggle: false
    })
  }

  selectorLiClick = (index) => {
    const { queryMonthList } = this.state;
    queryMonthList.map(t => { t.current = false });
    console.log(index, queryMonthList, 'queryMonthListqueryMonthList')
    queryMonthList[index].current = true;
    this.setState({
      queryMonthList,
      queryDate: queryMonthList.find(item => item.current).val
    }, () => {
      this.search();
    })
  }

  selectorUl = (e) => {
    e.stopPropagation();
    this.setState(({ selectToggle }) => ({ selectToggle: !selectToggle }));
  }

  tabLi = (index) => {
    const { tabData } = this.state;
    tabData.map(item => { item.active = false });
    tabData[index].active = true;
    this.setState({
      tabData,
      queryType: tabData.find(item => item.active).id
    }, () => {
      this.search();
    })
  }

  search = () => {
    // console.log(this.state.queryDate, this.state.queryType, 'queryDate, queryType')
    let { queryDate, queryType } = this.state;
    Commun.get('/api/user/star/detail', { month: queryDate, tradeType: queryType }).then((res) => {
      this.setState({
        starTotal: res.starTotal,
        resultMonthList: res.rows
      })
    })
  }

  render() {
    const { queryMonthList, selectToggle, resultMonthList, tabData, starTotal } = this.state;
    return (
      <div className={styles.queryCon} onClick={() => this.closeToggleUl()}>
        <ul className={styles.tabCon}>
          {
            tabData.length && tabData.map((item, index) => (
              <li
                key={item.id}
                className={`${styles.tabItem} ${styles[item.active ? 'tabItemActive' : '']}`}
                onClick={() => this.tabLi(index)}
              >
                {item.val}
              </li>
            ))
          }
        </ul>
        <div className={styles.datePickerCon}>
          <div className={`${styles.selector} ${styles[selectToggle ? 'open' : '']}`} onClick={(e) => this.selectorUl(e)}>
            <span>{queryMonthList.length && queryMonthList.find(item => item.current).val}</span>
            <ul style={{ display: selectToggle ? 'block' : 'none' }} className={styles.customScrollbar}>
              {queryMonthList.length && queryMonthList.map((item, index) => (
                <li key={item.val} className={`${styles[item.current ? 'currentMonth' : '']}`} onClick={(e) => this.selectorLiClick(index)}>{item.val}</li>
              ))}
            </ul>
          </div>
          <div className={styles.monthStarNum}>本月共计{starTotal}颗</div>
        </div>
        <ul className={`${styles.starList} ${styles.customScrollbar}`}>
          {
            resultMonthList.length ?
              resultMonthList.map((item, index) => (
                <li key={index}>
                  <div className={styles.left}>
                    <p className={styles.reason}>{item.category}</p>
                    <p className={styles.className}>{item.classname}</p>
                  </div>
                  <div className={styles.right}>
                    {tabData.find(item => item.active).id === 1 ? '+' : '-'}{item.starNum}
                  </div>
                </li>
              ))
              :
              <div className={styles.noData}>
                <img src={require('../../assets/img/starList/p-list-course.png')} />
                <p className={styles.noDataDesc}>空空如也～</p>
              </div>
          }
        </ul>
      </div>
    )
  }
}
export default StarListQuery;